import { Metadata } from 'next'

const title = 'Partner with Us | Ship&Play'
const description =
  'Partner with us to offer premium, door-to-door luggage shipping to your guests. ' +
  "It's easy to implement and free to join, with support every step of the way."
const url = 'https://www.shipplay.com/partnership-benefits'
const image = 'https://media.shipplay.com/ship-sticks-og-image.png'

const metadata: Metadata = {
  title,
  description,
  alternates: {
    canonical: url,
  },
  openGraph: {
    type: 'website',
    url,
    siteName: 'Ship&Play',
    title,
    description,
    images: [
      {
        url: image,
        width: 1200,
        height: 630,
        alt: 'Partner with Ship&Play — premium door-to-door luggage shipping for your guests',
      },
    ],
  },
  twitter: {
    card: 'summary_large_image',
    title,
    description,
    images: [image],
  },
}

export default metadata
